<h2 mat-dialog-title>Extend Session</h2>
<mat-dialog-content>
  <p>Your session is about to expire. Click extend to be able to continue to make edits or save changes.</p>
  <p>Time left: {{timeString}}</p>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-flat-button color="secondary" (click)="onNoClick()">Cancel</button>
  <button mat-flat-button color="primary" (click)="onYesClick()" cdkFocusInitial>Extend</button>
</mat-dialog-actions>